import React, { FC, useState } from 'react'
import { IoInformationCircle } from 'react-icons/io5'
import Modal from 'react-modal'

import { IconName } from 'Components/Icon'
import { IconButton } from 'Components/IconButton'
import { modalZIndexPriority } from 'Utils/zIndexPriority'

const ICON_SIZES = { small: '1.2rem', default: '1.75rem' } as const

type InfoModalProps = {
  children: string | React.ReactNode
  size?: 'small' | 'default'
}

const InfoModal: FC<InfoModalProps> = ({ children, size = 'default' }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        className="infomodal-icon-container"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label="Information anzeigen"
        aria-expanded={isOpen}
        aria-controls="infomodal-content"
      >
        <IoInformationCircle size={ICON_SIZES[size]} className="info-icon" />
      </button>

      <Modal
        style={modalZIndexPriority}
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        ariaHideApp={false}
        contentLabel="Information"
      >
        <div className="modal is-medium toolbar-modal white-background">
          <div className="toolbar-modal-header bg-blue-2">
            <div className="row justify-content-between align-items-center p-2">
              <h2 className="text-white">Information</h2>
              <IconButton name={IconName.close} onClick={() => setIsOpen(false)} color="white" />
            </div>
          </div>

          <article
            id="infomodal-content"
            className="toolbar-modal-body infomodal-content-wrapper custom-scrollbar pt-3 px-5"
          >
            {children}
          </article>
        </div>
      </Modal>
    </>
  )
}

export default InfoModal
